<div class="ecran-trajet">
	<alert class="alerte-trajets" [nom]="NOM_ALERTE_TRAJETS"></alert>

	<div class="gestion-trajet">
		<app-liste-trajets (basculerEnModeCreationModificationTrajet)="basculerEnModeCreationModificationTrajet()" [modeGestionNavette]="modeGestionNavette()"></app-liste-trajets>
		<div class="detail-trajet">
			@if (modeGestionNavette() === ModeGestionNavette.CREATION_MODIFICATION) {
				<app-creation-modification-trajet (fermerCreationModificationEvent)="basculerEnModeSelectionTrajet()"></app-creation-modification-trajet>
			} @else if (modeGestionNavette() === ModeGestionNavette.SELECTION && estTrajetSelectionne()) {
				<app-details-trajet (basculerEnModeModificationTrajet)="basculerEnModeCreationModificationTrajet()"></app-details-trajet>
			} @else {
				<div class="aucun-trajet-selectionne">
					{{ 'GESTION_NAVETTE.TRAJETS.SELECTIONNER_TRAJET' | translate }}
				</div>
			}
		</div>
	</div>
</div>